import ProductRecommendation from './ProductRecommendation.vue';

export const productRecommendationRoutes = [
  { path: 'product-recommendation', component: ProductRecommendation, name: 'product-recommendation' }
];
